import { createTypes, createAction } from "lib/action";

const LOAD_SLUMP = createTypes("slump", "load");
const SHOW_SLUMP = createTypes("slump", "show");
const CREATE_SLUMP = createTypes("slump", "create");
const UPDATE_SLUMP = createTypes("slump", "update");
const DELETE_SLUMP = createTypes("slump", "delete");
const IMPORT_SLUMP = createTypes("slump", "import");
const EXPORT_SLUMP = createTypes("slump", "export");

const loadSlumps = {
  request: (params, token) =>
    createAction(LOAD_SLUMP.REQUEST, { params, token }),
  success: (data) => createAction(LOAD_SLUMP.SUCCESS, { data }),
  failure: (err) => createAction(LOAD_SLUMP.FAILURE, { err }),
};

const showSlump = {
  request: (id, token) => createAction(SHOW_SLUMP.REQUEST, { id, token }),
  success: (data) => createAction(SHOW_SLUMP.SUCCESS, { data }),
  failure: (err) => createAction(SHOW_SLUMP.FAILURE, { err }),
};

const createSlump = {
  request: (params, token) =>
    createAction(CREATE_SLUMP.REQUEST, { params, token }),
  success: (data) => createAction(CREATE_SLUMP.SUCCESS, { data }),
  failure: (err) => createAction(CREATE_SLUMP.FAILURE, { err }),
};

const updateSlump = {
  request: (params, id, token) =>
    createAction(UPDATE_SLUMP.REQUEST, { params, id, token }),
  success: (data) => createAction(UPDATE_SLUMP.SUCCESS, { data }),
  failure: (err) => createAction(UPDATE_SLUMP.FAILURE, { err }),
};

const deleteSlump = {
  request: (id, token) => createAction(DELETE_SLUMP.REQUEST, { id, token }),
  success: (id) => createAction(DELETE_SLUMP.SUCCESS, { id }),
  failure: (err) => createAction(DELETE_SLUMP.FAILURE, { err }),
};

const importSlump = {
  request: (file, company_id, token) =>
    createAction(IMPORT_SLUMP.REQUEST, { file, company_id, token }),
  success: (data) => createAction(IMPORT_SLUMP.SUCCESS, { data }),
  failure: (err) => createAction(IMPORT_SLUMP.FAILURE, { err }),
};

const exportSlump = {
  request: (token) => createAction(EXPORT_SLUMP.REQUEST, { token }),
  success: (data) => createAction(EXPORT_SLUMP.SUCCESS, { data }),
  failure: (err) => createAction(EXPORT_SLUMP.FAILURE, { err }),
};

export {
  loadSlumps,
  showSlump,
  createSlump,
  updateSlump,
  deleteSlump,
  importSlump,
  exportSlump,
  LOAD_SLUMP,
  SHOW_SLUMP,
  CREATE_SLUMP,
  UPDATE_SLUMP,
  DELETE_SLUMP,
  IMPORT_SLUMP,
  EXPORT_SLUMP,
};
